import React from 'react';
import classNames from 'classnames/bind';
import styles from 'css/components/about';
import {FormattedMessage} from 'react-intl';

const cx = classNames.bind(styles);

/*
 * Note: This is kept as a container-level component,
 *  i.e. We should keep this as the container that does the data-fetching
 *  and dispatching of actions if you decide to have any sub-components.
 */
const About = () => {
  return (
    <div className="container text-center">
      <h1 ><FormattedMessage id="aboutUs.title"/></h1>
      <br/>
      <h4><FormattedMessage id="aboutUs.r1"/></h4>
      <p><FormattedMessage id="aboutUs.r2"/></p>
      <p><FormattedMessage id="aboutUs.r3"/></p>
      <p><FormattedMessage id="aboutUs.r4"/></p>
      <p><FormattedMessage id="aboutUs.r5"/></p>
      <p>Email: <a href="mailto:contact@growth-connections.com">Contact</a></p>
    </div>
  );
};

export default About;



// WEBPACK FOOTER //
// app/containers/About.jsx